import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled.div``;
export const Heading = styled.section``;
export const H2 = styled.h2`
  position: relative;
  padding: 10px;
  font-size: 28px;
  font-weight: 800;
  color: #ed563b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0px;
  margin-bottom: 0px;
`;
export const Span = styled.span`
  font-style: normal;
  color: #232d39;
`;
export const Form = styled.form`
  background-color: #232d39;
  height: 500px;
  position: absolute;
  width: 750px;
  left: 27%;
  border-radius: 15px;
  top: 100px;
`;
export const Title = styled.p`
  color: #ed563b;
  font-size: 26px;
  position: absolute;
  margin-left: 50px;
  margin-top: 10px;
`;
export const Error = styled.span`
  color: red;
  position: relative;
  top: 35px;
  right: 250px;
`;
export const Refresh = styled.button`
  position: absolute;
  margin: 120px 1050px;
  z-index: 999;
  border: none;
  background-color: #232d39;
`;

export const Icon = styled(FontAwesomeIcon)`
  color: #ed563b;
  font-size: 22px;
`;
